import * as React from 'react';
import Panel from '../panel/Panel';
import { useStores } from '../../stores';
import { Button, Tab, Tabs } from '@mui/material';
import { observer } from 'mobx-react-lite';
import NewPublisherDialog from './dialogs/NewPublisherDialog';
import { useTranslation } from "react-i18next";
import Can from '../../components/Can';
import { useOpenDialog } from '../../hooks/useOpenDialog';
import PublishersTab from './publishers/PublishersTab';
import InactivePublishersTab from './inactive/InactivePublishersTab';
import DeletedPublishersTab from './deleted/DeletedPublishersTab';
import { isMobile } from 'react-device-detect';
import { useNavigate } from 'react-router-dom';

const PublishersPage = observer(() => {
    const { t } = useTranslation();
    const { panelStore } = useStores();
    const navigate = useNavigate();
    const { isOpen, openDialog, closeDialog } = useOpenDialog();
    const [tab, setTab] = React.useState(panelStore.publishersPage.tab);

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setTab(newValue);
        panelStore.setPublishersPageTab(newValue)
    };

    const headerItems = () => {
        const items = [];
        if (!isMobile) {
            items.push(
                <Can key="emergency_contact_btn" do="read" on='Publisher'>
                    <Button
                        type="button"
                        color="inherit"
                        onClick={() => navigate('/emergency-contacts')}>
                        {t("show_emergency_contacts")}
                    </Button>
                </Can>
            )
        }
        items.push(
            <Can key="new_publisher_btn" do="create" on='Publisher'>
                <Button
                    type="button"
                    color="inherit"
                    onClick={() => openDialog("new-publisher")}>
                    {t("add_new_publisher")}
                </Button>
            </Can>
        );
        return items;
    }

    return (
        <Panel
            title={t("publishers")}
            headerItems={headerItems()}
        >
            <Tabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
                <Tab label={t("congregation")} />
                <Tab label={t("inactives")} />
                <Tab label={t("deactivated")} />
            </Tabs>
            <div role="tabpanel" hidden={tab !== 0}>
                <PublishersTab />
            </div>
            <div role="tabpanel" hidden={tab !== 1}>
                <InactivePublishersTab />
            </div>
            <div role="tabpanel" hidden={tab !== 2}>
                <DeletedPublishersTab />
            </div>

            <NewPublisherDialog
                isOpen={isOpen("new-publisher")}
                onClose={closeDialog} />
        </Panel >
    );
});

export default PublishersPage;